import { motion } from "framer-motion";

const SectionDivider = () => (
  <motion.div
    initial={{ scaleX: 0 }}
    whileInView={{ scaleX: 1 }}
    viewport={{ once: true, margin: "-40px" }}
    transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
    className="h-px bg-foreground/[0.07] origin-left mx-5 md:mx-10 lg:mx-14"
  />
);

export default SectionDivider;
